import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import type { CreateTaxSeriesDialogProps } from './types';

export const CREATE_TAX_SERIES_DIALOG = 'CREATE_TAX_SERIES_DIALOG';

export const dispatchCreateTaxSeriesDialog = (props?: CreateTaxSeriesDialogProps) => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: CREATE_TAX_SERIES_DIALOG,
        props: ImmutableMap(props || {}),
      }),
    ),
  );
};

export default dispatchCreateTaxSeriesDialog;
